import { AloftPrice, AloftPriceJSON } from '@aloft/shared-objects';

export const getDepreciationRowLabel = (index: number) => (index === 0 ? 'SUB' : `CP ${index}`);

export const calculateDifferenceInDepreciation = (
  subjectDepreciation?: AloftPriceJSON,
  compDepreciation?: AloftPriceJSON,
) => {
  if (!subjectDepreciation || !compDepreciation) return undefined;

  return AloftPrice.schema
    .parse(subjectDepreciation)
    .sub(AloftPrice.schema.parse(compDepreciation));
};

export const getDepreciationDifferenceString = (depreciationDifference?: AloftPrice | string) => {
  if (!depreciationDifference) return '-';

  if (typeof depreciationDifference === 'string') return depreciationDifference;
  return depreciationDifference.toString(true);
};
